import React from 'react';
import {i18n} from '@netx/core/i18n';
import {
	ClearToggle,
	type ClearToggleProps,
} from '@netx/core-components/ClearToggle/ClearToggle';

export interface AttributeClearToggleProps extends ClearToggleProps {}

const AttributeClearToggle = ({
	disabled,
	...props
}: AttributeClearToggleProps) => {
	return (
		<ClearToggle
			{...props}
			disabled={disabled}
			// fallback to default title if not disabled
			label={disabled ? i18n.t('i18n.mandatory') : undefined}
		/>
	);
};

export default AttributeClearToggle;
